<div class="flex flex-column align-items-start gap-3 align-self-stretch pb-4 pt-4">
  <fieldset class="sps-fieldset form-data-container" [ngClass]="paymentPageLinkData.type === 'DONATION' ? 'separator' : null">
    <div class="grid w-full">
      <div class="col-6 flex flex-column gap-2">
        <label for="link-name">{{ i18n.i18nLng()['BUTTONTEXT'] }}<sup class="sps-sup">*</sup></label>
        <input pInputText
               id="link-button-text"
               maxLength="25"
               [pAutoFocus]="true"
               [(ngModel)]="paymentPageLinkData.buttonText"
               [required]="true"
               (ngModelChange)="dataChanged.emit()"
               [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
               [ngClass]="paymentPageLinkInvalidFlags.buttonText ? 'ng-invalid ng-dirty' : null"
               [attr.aria-invalid]="paymentPageLinkInvalidFlags.buttonText"
               [attr.aria-describedby]="paymentPageLinkInvalidFlags.buttonText ? 'button-text-invalid-help' : null"
               pSize="large"/>
        @if (paymentPageLinkInvalidFlags.buttonText) {
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="button-text-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
        }
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="currency">
          {{ i18n.i18nLng()['LANGUAGE'] }}<sup class="sps-sup">*</sup>
        </label>
        <p-select [(ngModel)]="paymentPageLinkData.languageKey"
                  inputId="language"
                  [options]="languageList"
                  [showClear]="false"
                  [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                  (ngModelChange)="dataChanged.emit()"
                  optionLabel="label"
                  optionValue="value"
                  class="w-full"
                  size="large"
                  appendTo="body"
                  [attr.aria-label]="i18n.i18nLng()['LANGUAGE']"
                  [attr.aria-invalid]="paymentPageLinkInvalidFlags.languageKey"
                  [attr.aria-describedby]="paymentPageLinkInvalidFlags.languageKey ? 'language-invalid-help' : null"
                  [ngClass]="paymentPageLinkInvalidFlags.languageKey ? 'ng-invalid ng-dirty' : null"/>
        @if (paymentPageLinkInvalidFlags.languageKey) {
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="language-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
        }
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="link-css-class">{{ i18n.i18nLng()['LINKCSSCLASS'] }}</label>
        <input pInputText
               id="link-css-class"
               [(ngModel)]="paymentPageLinkData.cssClassName"
               [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
               [maxlength]="70"
               [ngClass]="paymentPageLinkInvalidFlags.cssClassName  ? 'ng-invalid ng-dirty' : null"
               [attr.aria-invalid]="paymentPageLinkInvalidFlags.cssClassName"
               [attr.aria-describedby]="paymentPageLinkInvalidFlags.cssClassName ? 'css-class-invalid-help' : null"
               pSize="large"/>
        @if (paymentPageLinkInvalidFlags.cssClassName) {
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="css-class-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
        }
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="merchant-ref-id">{{ i18n.i18nLng()['MERCHANTREFERENCEID'] }}</label>
        <input pInputText
               id="merchant-ref-id"
               [(ngModel)]="paymentPageLinkData.merchantTxId"
               [maxlength]="255"
               [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
               [ngClass]="paymentPageLinkInvalidFlags.merchantRefId  ? 'ng-invalid ng-dirty' : null"
               [attr.aria-invalid]="paymentPageLinkInvalidFlags.merchantRefId"
               [attr.aria-describedby]="paymentPageLinkInvalidFlags.merchantRefId ? 'merchant-ref-id-invalid-help' : null"
               pSize="large"/>
        @if (paymentPageLinkInvalidFlags.merchantRefId) {
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="merchant-ref-id-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
        }
      </div>
      <div class="col-12 flex flex-column gap-2">
        <label for="information-text">{{ i18n.i18nLng()['INFORMATIONTEXT'] }}</label>
        <input pInputText
               id="information-text"
               [(ngModel)]="paymentPageLinkData.informationText"
               [maxlength]="100"
               [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
               [ngClass]="paymentPageLinkInvalidFlags.informationText  ? 'ng-invalid ng-dirty' : null"
               [attr.aria-invalid]="paymentPageLinkInvalidFlags.informationText"
               [attr.aria-describedby]="paymentPageLinkInvalidFlags.informationText ? 'information-text-invalid-help' : 'information-text-help'"
               pSize="large"/>
        <small style="line-height: 1.5rem" role="contentinfo" id="information-text-help">{{ i18n.i18nLng()['INFORMATIONTEXTINFO'] }}</small>
        @if (paymentPageLinkInvalidFlags.informationText) {
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="information-text-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
        }
      </div>
      <div class="col-12 flex flex-column gap-2">
        <label for="payment-link-success-url">{{ i18n.i18nLng()['PAYMENTLINKSUCCESSURL'] }}</label>
        <input pInputText
               id="payment-link-success"
               maxlength="2048"
               [(ngModel)]="paymentPageLinkData.successUrl"
               [required]="false"
               [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
               pSize="large"/>
      </div>
      <br/>
      <div class="col-12 flex flex-column gap-2">
        <label for="payment-link-fail-url">{{ i18n.i18nLng()['PAYMENTLINKFAILURL'] }}</label>
        <input pInputText
               id="payment-link-fail"
               maxlength="2048"
               [(ngModel)]="paymentPageLinkData.failUrl"
               [required]="false"
               [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
               pSize="large"/>
      </div>
      <br/>
      <div class="col-12 flex flex-column gap-2">
        <label for="payment-link-back-url">{{ i18n.i18nLng()['PAYMENTLINKBACKURL'] }}</label>
        <input pInputText
               id="payment-link-back"
               maxlength="2048"
               [(ngModel)]="paymentPageLinkData.backUrl"
               [required]="false"
               [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
               pSize="large"/>
      </div>
      <br/>
      <div class="col-12 flex flex-column gap-2">
        <label for="payment-link-notify-url">{{ i18n.i18nLng()['PAYMENTLINKNOTIFYURL'] }}</label>
        <input pInputText
               id="payment-link-notify"
               maxlength="2048"
               [(ngModel)]="paymentPageLinkData.notifyUrl"
               [required]="false"
               [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
               pSize="large"/>
      </div>
    </div>
  </fieldset>
  @if (paymentPageLinkData.type === 'DONATION') {
    <fieldset class="sps-fieldset form-data-container separator">
      <div class="flex flex-column pb-2">
        <legend class="p-dialog-title">{{ i18n.i18nLng()['DONATIONPROJECTS'] }}</legend>
      </div>
      <div class="grid w-full align-items-center">
        <div class="col-12 flex flex-column gap-2">
          <label for="donation-project-name">{{ i18n.i18nLng()['DONATIONPROJECTNAME'] }}</label>
          <input pInputText
                 id="donation-project-name"
                 [(ngModel)]="newDonationProjectName"
                 [maxlength]="100"
                 [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                 (keydown.enter)="addNewDonationProject()"
                 pSize="large"/>
          <small style="line-height: 1.5rem" role="contentinfo" id="project-name-help">{{ i18n.i18nLng()['CONFIRMPROJECTNAME'] }}</small>
        </div>
        <div class="col-12 flex chip-container">
          @for (project of paymentPageLinkData.donationProjectList; track project) {
            <p-chip [label]="project"
                    [removable]="true"
                    (onRemove)="removeDonationProject(project)">
            </p-chip>
          }
        </div>
      </div>
    </fieldset>
  }
</div>
